import { Col, ColType, Crud, CrudApi,CrudAction } from "../../comp/crud";
import { FormApi } from "@douyinfe/semi-ui/lib/es/form";
import { TextCell,TextCellRemark } from "../../comp/cell";
import {
  ApiClient,
  displayTodoStatus,
  getTodoStatusOpt,
  LeadContactLog,
} from "../../api/ApiClient";
import React, { useContext, useEffect, useState } from "react";
import { Form, Modal, Typography, SideSheet, Button, Tag, Toast } from "@douyinfe/semi-ui";
import {IconBell, IconMail, IconModalStroked} from "@douyinfe/semi-icons";


let apiClient = ApiClient.getDefault();
const { Text } = Typography;

export interface TodoCrudProps {
  visible: boolean
  onCancel?: () => void

}

export function TodoLoanCrud(props: TodoCrudProps) {

  const [app, setApp] = useState(undefined as undefined | any);
  const [crudApi, setCrudApi] = useState(undefined as undefined | CrudApi);
  const role = localStorage.getItem("role");
  const [showTodo, setShowTodo] = useState(false);
  const [todoFormApi, setTodoFormApi] = useState<FormApi>();
  const [savingTodo, setSavingTodo] = useState(false);
  const [leadId, setLeadId] = useState<number>();
  const [todoId, setTodoId] = useState<number>();
  const [leadContactLogsSelect, setLeadContactLogsSelect] = useState(
    [] as any[]
  );

  const userRealName = localStorage.getItem("userRealName");

  useEffect(() => {

  }, []);


  let colsLoan: Col[] = [
    {
      name: "发起人",
      key: "createdByName",
      width: 80,
      showInFilter: true,
      type: ColType.STRING,
    },
    {
      name: "提醒人",
      key: "userName",
      width: 80,
      showInFilter: true,
      type: ColType.STRING,
    },
    {
      name: "客户",
      key: "leadName",
      width: 90,
      showInFilter: true,
      type: ColType.STRING,
      render: (value, record, index) => {
        return (
          <Button
            theme="borderless"
            type="tertiary"
            onClick={() => detailAction(record.leadId)}
          >
            {value}
          </Button>
        );

      },
    },
    
    {
      name: "状态",
      key: "done",
      width: 80,
      showInFilter: true,
      type: ColType.SELECT,
      getOptions: (row) => Promise.resolve(getTodoStatusOpt()),
      render: (value, index) => {
        if (value == "A_UNDO") {
          return (
            <Tag color="red" key={value} size='large'
            shape='circle'
            type='solid'> {displayTodoStatus(value)} </Tag>
          );
          
        } else {
          return (
            <Tag color="green" key={value} size='large'
            shape='circle'
            type='solid'> {displayTodoStatus(value)} </Tag>
          );
        }
      },
    },
    {
      name: "发起时间",
      key: "createdAt",
      width: 160,
      type: ColType.DATETIME,
      defaultSortOrder: "descend",
    },
    {
      name: "提醒内容",
      key: "content",
      type: ColType.STRING,
      render: (a, b, c) => (
        <TextCellRemark moreText={b.replyLogs ? b.replyLogs : []} width={350} text={a} />
      ),
    },
    {
      name: "城市",
      key: "leadCity",
      width: 60,
      hideInCreate: true,
      showInFilter: true,
      type: ColType.SELECT,
      getOptions: () => apiClient.getDictAsOpts("city"),
    },
   
    
  ];

  const getReplyTodoUserId = (todoId:number) => {
    return apiClient
      .getLoanReplyTodoUserId(todoId!)
      .then((logs) => {
        
        setLeadContactLogsSelect(logs);
        setShowTodo(true);
      });
  };



  const handleTodoSubmit = async () => {
    await todoFormApi!.validate();
    const values = todoFormApi!.getValues();
    const content = values["content"];
    const userId = values["userId"];
    setSavingTodo(true);
    try {
      await apiClient.request("/leadLoans/replyLeadLoanTodo", "POST", undefined, {
        leadId: leadId,
        srcTodoId:todoId,
        userId:userId,
        content: content,
      });
      setSavingTodo(false);
      todoFormApi?.reset();
      setShowTodo(false);
      Toast.info("保存成功");

      crudApi?.refresh();
    } catch (e) {
      setSavingTodo(false);
    }
  };

  //打开详情
  const detailAction = (leadId: number) => {
    const w = window.open("about:blank");
    if (w != null) {
      const data = {
        id: leadId,
        ids: [],
      };
      w.location.href =
        "/#/loanlead?data=" + encodeURIComponent(JSON.stringify(data));
    }
  };

  return (
    <SideSheet style={{ width: '1200px' }} title="按揭提醒事项" visible={props.visible} onCancel={props.onCancel} >
      <Modal
          icon={<IconModalStroked size={"extra-large"} style={{ color: 'blue' }}/>}
        title="回复"
        visible={showTodo}
        onCancel={() => setShowTodo(false)}
        onOk={handleTodoSubmit}
        confirmLoading={savingTodo}
      >
        
        <Form getFormApi={(api) => setTodoFormApi(api)}>
        <Form.Select
            rules={[{ required: true, message: "请选择" }]}
            initValue={leadContactLogsSelect.length>0?leadContactLogsSelect[0].userId:""}
            style={{ width: "100%" }}
            field="userId"
            label="回复"
          >
            {leadContactLogsSelect.map((l) => (
              <Form.Select.Option key={l.userId + ""} value={l.userId} >
                {l.userName}
              </Form.Select.Option>
            ))}
          </Form.Select>
          
          <Form.TextArea
            rules={[{ required: true, message: "请填写" }]}
            placeholder="回复内容"
            rows={2}
            noLabel
            field="content"
          />
        
        </Form>
      </Modal>

      <Crud
        getCrudApi={(crudApi) => {
          setCrudApi(crudApi);
        }}
        canUpdate={false}
        canCreate={false}
        select={false}
        name="提醒信息"
        entityKey="todos/listLoanTodo"
        pageSize={50}
        getRowActions={(a) => {
          // let detailAction = {
          //   name: "详情",
          //   action: () => {
          //     const w = window.open("about:blank");
          //     if (w != null) {
          //       const data = {
          //         id: a.leadId,
          //         ids: [],
          //       };
          //       w.location.href =
          //         "/#/loanlead?data=" + encodeURIComponent(JSON.stringify(data));
          //     }
          //   }
          // };

          let replyAction = {
            name: "回复",
            action: () => {
              let selectUsers = [];
              if(a.createdBy == a.userId){
                if(a.createdByName != userRealName){
                  selectUsers.push({
                    userId:a.userId,
                    userName:a.userName
                  });
                }
                
              }else{
               
                if(a.createdByName != userRealName){
                  selectUsers.push({
                  userId:a.createdBy,
                  userName:a.createdByName
                });
                }
                if(a.userName != userRealName){
                  selectUsers.push({
                    userId:a.userId,
                    userName:a.userName
                  });
                }
               
              }
              setLeadContactLogsSelect(selectUsers);
              //getReplyTodoUserId(a.id);
               setLeadId(a.leadId);
               setTodoId(a.id);
               setShowTodo(true);
            }
          };
          let doneAction = {
            name: "已读",
            action: () => {
              apiClient.updateLoanTodoDone(a.id);
              crudApi?.refresh();
              
            }
          };
          let deleteAction = {
            name: "清除",
            action: () => {
              apiClient.deleteLoanTodo(a.id);
              crudApi?.refresh();
            }
          };

          const actions: CrudAction[] = [];
          actions.push(replyAction);
          //actions.push(detailAction);
          actions.push(doneAction);
          // if(a.todoType == "QUESTION"){
          //   actions.push(replyAction);
          //   actions.push(detailAction);
          // }else{
          //   actions.push(doneAction);
          //   actions.push(detailAction);
          // }
          
          if (role == "agent_manager"||role == "root"||role == "op_manager") {
            actions.push(deleteAction);
          }
          return actions;
          
        }
        }
        cols={colsLoan}
      />
  
    </SideSheet>
  );
}
